import { disciplineAction } from './discipline-slice'
import { coursesApi } from '../utils'
import { throwApiError } from '../components/lms-shared/store/error-handling-actions';

export const getCoursesData = (includePastYears) => {

    return async (dispatch, getState) => {
        const state = getState();
        const data = {
            applicationId: state.application.applicationId,
            includePastYears: includePastYears ? includePastYears : false
        }
        coursesApi.coursesFilterRangePost({ coursesRangeFilter: data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: state.translate.texts.coursesFilterError, error: error, statusCode: response?.statusCode, message: "coursesFilterRangePost " + error.message, level: 2, component: "CoursesPage", line: 29 }))
            } else {
                dispatch(disciplineAction.init(resdata.map(r => {
                    const parse = r.additionalData && JSON.parse(r.additionalData)
                    return {
                        id: r.id,
                        name: r.name,
                        description: r.description,
                        backgroundImage: parse?.CardBackgroundImage,
                        baseColor: parse?.baseColor,
                        literalYear: state.studyYears.years[r.year]?.[state.translate.lang],
                        year: r.year,
                        fromClass: r.fromClass,
                        toClass: r.toClass,
                        baseUrl: r.baseUrl,
                        active: r.active,
                        recommendedClass: r.recommendedClass,
                        lang: r.lang
                    }
                })))
            }
        })
    }
}
